<template>
	<v-container>
		<v-row>
			<v-col cols="12">
				<h2>
					Let's start a conversation
				</h2>
			</v-col>
			<v-col cols="12">
				<v-card dark>
					<v-card-title>
						Contact Info
					</v-card-title>
					<v-card-text>
						<v-text-field v-model="firstName" label="First Name"></v-text-field>
						<v-text-field v-model="lastName" label="Last Name"></v-text-field>
						<v-text-field v-model="company" label="Company/Organization"></v-text-field>
						<v-text-field ref="phone" :counter="10" :rules="phoneRules" v-model="phone" label="Phone Number"></v-text-field>
						<v-text-field ref="email" :rules="emailRules" v-model="email" label="Email"></v-text-field>
					</v-card-text>
				</v-card>
				<v-card dark>
					<v-card-title>
						Tell me what you have in mind...
					</v-card-title>
					<v-card-text>
						<v-textarea v-model="objective" label="What is your objective or goal?"></v-textarea>
						<v-textarea v-model="outcome" label="Describe a successful outcome."></v-textarea>
					</v-card-text>
				</v-card>
				<v-card dark>
					<v-card-title>
						Of these priorities, which two are the most important?
					</v-card-title>
					<v-card-text>
						<v-switch @click="priorityLastClicked = 'quality'" color="green" v-model="quality" label="Quality, this needs to be perfect."></v-switch>
						<v-switch @click="priorityLastClicked = 'speed'" color="green" v-model="speed" label="Speed, I need this NOW!"></v-switch>
						<v-switch @click="priorityLastClicked = 'price'" color="green" v-model="price" label="Price, I need this done on the thrify side of things."></v-switch>
					</v-card-text>
				</v-card>
				<v-card dark>
					<v-card-title>
						Choose a loose time frame.
					</v-card-title>
					<v-card-text>
						<v-container>
							<v-row>
								<v-col class="text-center" cols="12" sm="6">
									<span>Start Date</span><br />
									<v-date-picker v-model="startDate"></v-date-picker>
								</v-col>
								<v-col class="text-center" cols="12" sm="6">
									<span>End Date</span><br />
									<v-date-picker v-model="endDate"></v-date-picker>
								</v-col>
							</v-row>
						</v-container>
					</v-card-text>
				</v-card>
				<v-card class="text-center" dark>
					<v-card-text>
						<v-btn x-large @click="submit">Submit</v-btn>
					</v-card-text>
				</v-card>
				<v-overlay :value="submitted">
					<p>
						Your information has been submitted.<br />
						I will reach out soon.
					</p>
					<v-btn @click="submitted = false">
						Continue Exploring
					</v-btn>
				</v-overlay>
				<v-overlay :value="warning">
					<p v-for="warningMessage in warningMessages" :key="warningMessage.id">
						{{ warningMessage }}
					</p>
					<v-btn @click="resetWarning">Try Again</v-btn>
				</v-overlay>
				<v-card class="text-center" dark>
					<v-card-text>
						If forms aren't your thing feel free to reach out at <a style="color: #9e9e9e !important;" href="mailto:info@jesseddev.com">info@JesseDDev.com</a>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import { DB } from '../firebase/db'

export default {
	data() {
		return {
			firstName: '',
			lastName: '',
			quality: false,
			speed: false,
			price: false,
			priorityLastClicked: '',
			phone: '',
			company: '',
			startDate: '',
			endDate: '',
			objective: '',
			outcome: '',
			submitted: false,
			warning: false,
			warningMessages: [],
			phoneRules: [
				v => v.length == 10 || 'Not a working US Number',
				v => /[0-9]+[0-9]+[0-9]+[0-9]+[0-9]+[0-9]+[0-9]+[0-9]+[0-9]+[0-9]/.test(v) || 'Only enter numbers'
			],
			email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
		}
	},
	computed: {
		tooManyPriorities() {
			return this.quality && this.speed && this.price
		}
	},
	watch: {
		tooManyPriorities: function(val) {
			if(val){
				if(this.priorityLastClicked === 'price') {
					this.speed = false
				} else {
					this.price = false
				}
			}
		}
	},
	mounted() {
		window.scrollTo(0,0)
	},
	methods: {
		resetWarning() {
			this.warningMessages = []
			this.warning = false
		},
		submit() {
			if(!this.firstName || !this.lastName || !this.email) {
				if (!this.firstName) {
					this.warningMessages.push('Must include first name.')
				}
				if (!this.lastName) {
					this.warningMessages.push('Must include last name.')
				}
				if (!this.email) {
					this.warningMessages.push('Must include email.')
				}
				this.warning = true
			} else {
					DB.collection('inquiries')
						.add({
							firstName: this.firstName,
							lastName: this.lastName,
							quality: this.quality,
							speed: this.speed,
							price: this.price,
							phone: this.phone,
							company: this.company,
							startDate: this.startDate,
							endDate: this.endDate,
							email: this.email,
							objective: this.objective,
							outcome: this.outcome,
						})
					this.submitted = true
					this.firstName = ''
					this.lastName = ''
					this.quality = false
					this.speed = false
					this.price = false
					this.priorityLastClicked = ''
					this.phone = ''
					this.company = ''
					this.startDate = ''
					this.endDate = ''
					this.objective = ''
					this.outcome = ''
					this.warning = false
					this.warningMessages = []
					this.email = ''
					this.$refs.email.resetValidation()
					this.$refs.phone.resetValidation()
			}
		}
	}
}
</script>

<style scoped>

</style>